import { createApp } from 'vue'
import { createMemoryHistory, createRouter } from 'vue-router'
import App from './App.vue'
import HomePage from './HomePage.vue'
import AboutPage from './AboutPage.vue'

import SnowLoad from './pages/NBCC2015/SnowLoad.vue'
import WindLoadStaticLow from './pages/NBCC2015/WindLoadStaticLow.vue'
import WindLoadStaticTall from './pages/NBCC2015/WindLoadStaticTall.vue'
import ConcreteBeam from './pages/CSA A23.3-24/ConcreteBeam.vue'
import FoundationWall from './pages/CSA A23.3-24/FoundationWall.vue'
import StairVibration from "./pages/AISC Design Guide 11/StairVibration.vue";
import SteelColumn from "./pages/CSA S16-19/SteelColumn.vue";
import LagScrewWithdrawal from "./pages/CSA O86-19/LagScrewWithdrawal.vue";
import KaTeXComponent from "./components/KaTeXComponent.vue";
import BendingShear from "./pages/CSA O86-19/BendingShear.vue";
import PunchingShear from "./pages/CSA A23.3-24/PunchingShear.vue";
import CantileveredSoldierPileWall from "./components/CantileveredSoldierPileWall.vue"
import SnowLoadASCE716 from "./pages/ASCE7-16/SnowLoad.vue";

import BootstrapVue3 from 'bootstrap-vue-3';

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

// Import global styles
import './assets/styles/global.css'


const routes = [
    { path: '/', component: HomePage },
    { path: '/about', component: AboutPage },
    { path: '/snow-load', component: SnowLoad },
    { path: '/wind-load-static-low', component: WindLoadStaticLow },
    { path: '/wind-load-static-tall', component: WindLoadStaticTall },
    { path: '/concrete-beam', component: ConcreteBeam },
    { path: '/foundation-wall', component: FoundationWall },
    { path: '/stair-vibration', component: StairVibration },
    { path: '/steel-column', component: SteelColumn },
    { path: '/lag-screw-withdrawal', component: LagScrewWithdrawal },
    { path: '/bending-shear', component: BendingShear },
    { path: '/punching-shear', component: PunchingShear },
    { path: '/cantilevered-soldier-pile', component: CantileveredSoldierPileWall },
    { path: '/ASCE7-16/snow-load', component: SnowLoadASCE716 },
  ];

     
  const router = createRouter({
    history: createMemoryHistory(),
    routes,
  })

createApp(App).use(router).use(BootstrapVue3).component("KaTeXComponent", KaTeXComponent).mount('#app');
